import { setSessionStorage, getSessionStorage } from '@/utils/sessionStorage';
/**
 * 处理策略 存储策略
 * 示例为 特价菜限购超出限购提示策略
 * "strategy":{ "cycle":1, "num":1, "uniqueId":"eeafc83672cb35c68ee1f91edc3c4ad3_1" }
 */
export function isStrategyShow(key, strategy) {
  if (!strategy) {
    // delSessionStorage(key) 不清除原因：老客菜如果弹窗，后续再加特价菜会重复提示
    return true;
  }
  let { num = 1, uniqueId } = strategy;
  let storageObj = getSessionStorage(key);
  if (storageObj && storageObj.uniqueId === uniqueId && num <= storageObj.num) {
    return false;
  } else {
    let preNum = !storageObj
      ? 0
      : storageObj.uniqueId !== uniqueId
      ? 0
      : storageObj?.num || 0;
    setSessionStorage(key, { num: preNum + 1, uniqueId });
    return true;
  }
}

/**
 * 禁止H5 弹窗下边的页面滚动
 * 明确声明为不是被动的
 * 缺陷：会导致页面滚动到顶部
 */
export function stopScroll() {
  document.body.className =
    document.body.className + ' c-global-parent-overflow';
}
export function openScroll() {
  removeClass(document.body, 'c-global-parent-overflow');
}

function removeClass(el, name) {
  if (!el) return;
  let className = el.className;
  if (className) {
    let reg = new RegExp(name, 'g');
    el.className = className.replace(reg, '');
  }
}

/**
 * window.location.origin的兼容处理
 * 由于在Chrome window.location.origin 属性是支持的，但是在IE11不支持
 * @export
 * @returns String
 */
export function getUrlOrigin() {
  return (
    window.location.origin ||
    `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }`
  );
}
